'use strict';

const DeleteDatasetDialogDirective = function() {

  return {
    bindToController: true,
    controller: 'DeleteDatasetDialogController',
    controllerAs: 'vm',
    templateUrl: 'manager/processing/dialogs/deleteDatasetDialog.tpl.html'
  };
};

module.exports = DeleteDatasetDialogDirective;


// WEBPACK FOOTER //
// ./src/app/manager/processing/dialogs/DeleteDatasetDialogDirective.js